
import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { apiRequest, muviUserId, openInNewWindow } from "../../../../utils/utils";
import toast from "react-hot-toast";
import Cookies from "js-cookie";

const LoginToAccount = (props) => {

  const { data } = props;
  const [standard, setStandard] = useState(false);

  const standardChangeHandler = (evt) => {
    setStandard(evt.target.checked);
  };

  const loginSubmit = async (isStandard) => {
    const muvi_useruuid = Cookies.get("muvi_useruuid");

    let requestData = {
      product_key: data.product_key,
      user_uuid: data.user_uuid,
      // key: data && data.type,
      // server: data && data.server,
      muvi_userid: muviUserId().user_id,
      muvi_useruuid: muvi_useruuid,
      standard: isStandard,
      app_token: data.customer_id || "",
      mautic_id: data.mautic_id || "",
    };


    if (data.isMuvi5) {
      const {
        enterprise_api_gateway_url,
        encrypted_password,
        email,
        store_id,
        customer_id
      } = data;

      const baseUrl = enterprise_api_gateway_url || "https://cms.muvi.com";

      const params = new URLSearchParams({
        email,
        password: encrypted_password,
        studio_id: customer_id,
        muviEmployeeId: muviUserId().user_id,
      });


      const url = `${baseUrl}/login/storeLogin?${params.toString()}`;

      window.open(url, "_blank");
    } else {
      const responseData = await apiRequest(
        `${process.env.REACT_APP_CRM}/muvi6/auto-login`,
        "POST",
        requestData
      );
      if (responseData.code === 200) {
        openInNewWindow(responseData.data);
      } else {
        toast.error(responseData.message || "Something went wrong");
      }
    }
  };
  return (
    <Modal show={props.show} onHide={props.close} centered>
      <Modal.Header>
        <Modal.Title>{props.data.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5 style={{ color: "rgb(87, 87, 87)" }}>{props.data.confirmText}</h5>
      </Modal.Body>
      <Modal.Footer>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span>
            <input
              type="checkbox"
              name=""
              id=""
              onChange={standardChangeHandler}
            />{" "}
            Take me to staging account
          </span>
          <div>
            <Button
              type="button"
              variant="dark"
              className="btn-dark-btn"
              onClick={props.close}
            >
              Cancel
            </Button>
            <Button
              type="button"
              variant="primary"
              onClick={() => loginSubmit()}
            >
              Continue
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default LoginToAccount;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/LoginToAccount.js